export default "__VITE_ASSET__BE1U5WQ0__"